import React from 'react';
import AppContainer from '../app-container';
import LocalizedStrings from '../../localization/strings';
import DocumentTitle from 'react-document-title';
import {isEnglish} from '../../localization/language-cookie';

export default class GdprPageContainer extends AppContainer {

    renderGdprContent() {
        if (isEnglish()) {
            return (<div>


                <div>
                    <h4>Why we need your personal data?</h4>
                    <ul>
                        <li> To be able to send you a confirmation email after registration.</li>
                        <li> To be able to send you an email which would remind about the upcoming event you had
                            registered
                            to.
                        </li>
                        <li> To be able to see your payment status (either paid or not) in our system. This information
                            will
                            also be publicly shown on page “Stages” in Participants table.
                        </li>
                        <li> To be able to show your results in addition with other participants on the page “Results”.
                            We also
                            see all participants and their results in our system.
                        </li>
                        <li> For you to be able to find all your results from our organized events that you participated
                            in. It
                            will be shown on page “Participant results”.
                        </li>
                        <li> Also, we are using cookies to see where our page visitors came from and to see statistics
                            of the
                            page. IP address is used to find out the geolocation of a visitor and cookies are used for
                            frequency
                            of visits. We use Google Analytics which is GDPR compliant (<a
                                href="https://support.google.com/analytics/answer/6004245?hl=en&authuser=0">https://support.google.com/analytics/answer/6004245?hl=en&authuser=0</a>).
                        </li>
                    </ul>
                </div>
                <div>
                    <h4>What data we are collecting and how are we handling it?</h4>

                    <div>
                        Your full name, gender, birth date, email, phone, country and city you live in and the club you
                        belong to (if it is such a case). We use cookies which collect your IP address and by that we
                        can see the frequency of your visits to this site.
                    </div>
                    <div>
                        We store and secure your data for an unlimited time period. The data is used only by the
                        organizer of the event (unless stated differently in Regulations) and can only be transferred if
                        the law requires it.
                    </div>
                    <div>
                        We do not use your personal data for direct marketing unless you ticked that you agree to get
                        marketing emails when registering.
                    </div>
                </div>
                <div>
                    <h4>According to GDPR (General Data Protection Regulation) you have these four rights:
                    </h4>
                    <ol>
                        <li> To object our legitimate interest to have your data. After your objection we will mark in
                            our system to not contact you again.
                        </li>
                        <li>
                            To be forgotten. That means, you can ask us to delete all your data from our system. Also,
                            you can ask to fix your data if it is not up to date anymore.
                        </li>
                        <li>
                            To get a copy of data we have about you.
                        </li>
                        <li>
                            To ask that we would make you anonymous. This means you won’t be shown publicly between
                            participants or in results.
                        </li>
                    </ol>
                </div>
                <div>
                    If you have any questions about your personal data or you want to use any of your rights, please
                    contact <a
                    href="mailto:info@eventomanija.lt">info@eventomanija.lt</a>. We will answer your question or request
                    within 30 days.
                </div>

            </div>)
        } else {
            return (<div>
                <div>
                    <h4>Kodėl mums reikalingi Jūsų asmens duomenys:</h4>
                    <ul>
                        <li>Mes atsiųsime Jums registracijos patvirtinimo laišką.</li>
                        <li>Mes atsiųsime Jums priminimą apie renginį, į kurį užsiregistravote, laišką.</li>
                        <li>Savo sistemoje matysime, ar apmokėjote už renginį. Ši informacija su Jūsų pateiktais asmens
                            duomenimis taip pat bus matoma mūsų puslapyje Etapų skiltyje “Dalyviai”.
                        </li>
                        <li>Galėsime parodyti Jūsų rezultatus bendroje dalyvių rezultatų lentelėje (Skiltis
                            “Rezultatai”).
                        </li>
                        <li>Jūs galėsite susirasti savo rezultatus iš visų mūsų rengtų renginių skiltyje “Dalyvio
                            rezultatų
                            istorija”.
                        </li>
                        <li>Naudodami slapukus mes galėsime atpažinti Jūsų IP adresą ir nustatyti lankomumą puslapyje.
                            IP
                            adresas yra naudojamas norint sužinoti svetainės lankytojų geografines vietas, o lankomumas
                            naudojamas puslapio statistikai. Taip pat, mes naudojamės Google Analytics. Apie jų duomenų
                            apsaugą galite pasiskaityti čia
                            (<a href="https://support.google.com/analytics/answer/6004245?hl=en&authuser=0">https://support.google.com/analytics/answer/6004245?hl=en&authuser=0</a>).
                        </li>

                    </ul>
                </div>
                <div>
                    <h4>Kokius duomenis mes renkame ir kaip juos tvarkome?</h4>

                    <div>
                        Registruodamiesi Jūs pateikiate savo vardą, pavardę, lytį, gimimo datą, el. pašto adresą,
                        telefono
                        numerį. Taip pat, nurodote savo telefono numerį, šalį ir miestą, kuriame gyvenate bei klubą,
                        kuriam
                        priklausote (jei priklausote ir norite tai nurodyti). Savo svetainėje mes naudojame slapukus,
                        kurie
                        atpažįsta vartotojų IP adresus.
                    </div>
                    <div>
                        Jūsų asmens duomenys yra saugomi mūsų serveryje neribotą laiką. Surinkti duomenys yra naudojami
                        tik
                        renginio organizatoriaus (nebent nuostatuose nurodyta kitaip) ir niekam neperleidžiami, nebent
                        to
                        reikalauja teismas.
                    </div>
                    <div>
                        Tikslinės rinkodaros tikslais Jūsų duomenų nenaudojame, nebent registruodamiesi varnele
                        pažymėjote,
                        kad sutinkate gauti reklaminius pranešimus.

                    </div>
                </div>
                <div>
                    <h4>Pagal Bendrąjį Duomenų Apsaugos Reglamentą, Jūs turite šias keturias teises:</h4>
                    <ol>
                        <li> Prieštarauti mūsų teisei laikyti ir naudoti Jūsų asmens duomenis tam, kad siųstume
                            patvirtinimo ir priminimo laiškus. Po Jūsų prieštaravimo mes iš karto pažymėsime savo
                            duombazėje, kad daugiau su Jumis nekontaktuotume.
                        </li>
                        <li>Paprašyti duomenų, kuriuos turime surinkę apie Jus, kopijos.</li>
                        <li>
                            Paprašyti visų Jūsų duomenų ištrynimo iš mūsų sistemos arba pataisymo.
                        </li>
                        <li>
                            Paprašyti nuasmenininti Jūsų norimus duomenis. Tai reiškia, kad Jūsų duomenys (vardas,
                            pavardė,
                            t.t.) bus nerodomi viešai mūsų puslapyje.
                        </li>
                    </ol>
                </div>
                <div>
                    Dėl klausimų susijusių su Jūsų duomenų apsauga kreipkitės el. paštu: <a
                    href="mailto:info@eventomanija.lt">info@eventomanija.lt</a>. Atsakymus į klausimus pateiksime ne
                    vėliau kaip per 30 dienų.

                </div>

            </div>)
        }
    }

    render() {
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.gdprPageTitle)}>

                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{LocalizedStrings.gdprPageTitle}</span>
                        </h1>
                        <div className="post-body">{this.renderGdprContent()}</div>
                    </div>
                </div>
            </DocumentTitle>

        )
    }
}



// WEBPACK FOOTER //
// ./src/js/containers/pages/gdpr-page-container.js